import { Box, Flex, Section } from "@radix-ui/themes";
import { Navbar } from "../components/Navbar";
import { Countdown } from "../components/Countdown.tsx";
import ArticleContainer from "../components/ArticleContainer.tsx";

function Issues() {
  return (
    <Box>
      <Navbar />
      <Countdown />
      <Flex justify={"center"}>
        <Box width={"1000px"}>
          <Section>
            <ArticleContainer>
              <Box
                style={{
                  fontWeight: "bold",
                  fontSize: "20px",
                  marginBottom: "10px",
                  color:
                    "var(--ro-text)" /* Highlight color to match new color scheme */,
                }}
              >
                Known issues:
                <ul
                  style={{
                    color:
                      "var(--ro-text)" /* Highlight color to match new color scheme */,
                  }}
                >
                  <li>Not yet working on mobile [eta: week of Aug 4]</li>
                </ul>
              </Box>
            </ArticleContainer>
          </Section>
        </Box>
      </Flex>
    </Box>
  );
}

export default Issues;
